import React from "react";
import "./AdditionalInfoField.css";

function joinClasses(...parts) {
  return parts.filter(Boolean).join(" ");
}

export default function AdditionalInfoField({
  id = "additionalInfo",
  name = "additionalInfo",
  label = "Anything else to include? (optional)",
  value = "",
  onChange,
  maxLength = 4000,
  invalid = false,
  disabled = false,
  placeholder = "Notes, link, special instructions",
  wrapperClassName = "",
  labelClassName = "",
  counterClassName = "",
  textareaClassName = "",
}) {
  const safeValue = typeof value === "string" ? value : "";
  const count = safeValue.length;
  const overLimit = count > maxLength;
  const showInvalid = invalid || overLimit;

  return (
    <div className={wrapperClassName}>
      <label htmlFor={id} className={labelClassName}>
        {label}{" "}
        <span
          className={joinClasses(
            "tp-notes-counter",
            overLimit ? "is-over" : "",
            counterClassName
          )}
        >
          {count} / {maxLength}
        </span>
      </label>

      <textarea
        id={id}
        name={name}
        value={safeValue}
        onChange={(e) => onChange?.(e.target.value)}
        className={joinClasses(
          textareaClassName,
          showInvalid ? "is-invalid" : ""
        )}
        aria-invalid={showInvalid ? "true" : "false"}
        placeholder={placeholder}
        disabled={disabled}
      />
    </div>
  );
}
